module.exports = __webpack_public_path__ + "static/img/SearchDetailOperate5.6292637.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/QRcode/SearchDetailOperate5.png
// module id = 764
// module chunks = 0